import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import FormRow from '../../../components/FormRow'
import TextField from '../../../components/TextField'
import { fakeDataInsertion } from '../installService'
import { strings as S } from '../strings'

export default function DummyDataTab({ onRun }) {
  const [usersCount, setUsersCount] = useState('')

  return (
    <Card
      title={S.dummyData.cardTitle}
      footer={
        <Button
          variant="danger"
          disabled={usersCount === ''}
          onClick={() => onRun(() => fakeDataInsertion(Number(usersCount)))}
        >
          {S.dummyData.action}
        </Button>
      }
    >
      <FormRow label={S.dummyData.usersCountLabel}>
        {(id) => (
          <TextField id={id} type="number" value={usersCount} onChange={setUsersCount} />
        )}
      </FormRow>
    </Card>
  )
}
